import React from 'react';
import { components as reactSelectComponents } from 'react-select';
import classNames from 'classnames';
import BaseOption from '../components/base-option';

const renderOption = (Component = BaseOption) => {
  const RenderedOption = (optionProps) => {
    const { data, ...restProps } = optionProps;
    const {
      selectProps: { isTouchDevice: touchDevice, shouldMarkSelectedOption },
    } = optionProps;
    const classes = classNames({
      'ws-ui-base-select__option--is-touch-device': touchDevice,
      'ws-ui-base-select__option--not-marked-selected': !shouldMarkSelectedOption,
    });
    return (
      <reactSelectComponents.Option {...restProps} isDisabled={data.disabled} className={classes}>
        <div className="ws-ui-base-select__option-content">
          <Component {...data} {...restProps} />
        </div>
      </reactSelectComponents.Option>
    );
  };

  RenderedOption.displayName = 'RenderedOption';

  return RenderedOption;
};

export default renderOption;
